import { render } from "./DownloadedReports.vue?vue&type=template&id=b5c75dbe"
import script from "./DownloadedReports.vue?vue&type=script&lang=js"
export * from "./DownloadedReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__